import { Theme } from '@quillbot/design-system';
import { getPrimaryColor, unitPX } from './utils';
/**
 * Size
 */
export const w100p = { width: '100%' };
export const w100vw = { width: '100vw' };
export const h100p = { height: '100%' };

/**
 * Display
 */
export const displayNone = { display: 'none' };
export const displayBlock = { display: 'block' };
export const displayFlex = { display: 'flex' };
/**
 * Flex
 */
export const grow0 = { flexGrow: 0 };
export const grow = { flexGrow: 1 };
export const row = { flexDirection: 'row' };
export const column = { flexDirection: 'column' };
export const justifyStart = { justifyContent: 'flex-start' };
export const alignStart = { alignItems: 'flex-start' };
export const justifySpaceBetween = { justifyContent: 'space-between' };
export const alignCenter = { alignItems: 'center' };
export const center = { justifyContent: 'center', alignItems: 'center' };
/**
 * cursor
 */
export const cursorAuto = { cursor: 'auto' };
export const cursorDefault = { cursor: 'default' };
export const cursorPointer = { cursor: 'pointer' };

/**
 * bg
 */
export const backgroundColor = {
  paper: {
    backgroundColor: (theme: Theme) => theme.palette.background.paper,
  },
  default: {
    backgroundColor: (theme: Theme) => theme.palette.background.default,
  },
};

/**
 * text
 */
export const nonSelectable = { userSelect: 'none' };
export const breakWord = { wordBreak: 'break-word' };
export const truncate = { overflow: 'hidden', textOverflow: 'ellipsis' };
export const primaryColor = { color: getPrimaryColor };
export const txtCenter = { textAlign: 'center' };
export const fontSize = {
  12: {
    fontSize: 12,
  },
  14: {
    fontSize: 14,
  },
  16: {
    fontSize: 16,
  },
  20: {
    fontSize: 20,
  },
};
export const fontWeight = {
  400: {
    fontWeight: 400,
  },
  600: {
    fontWeight: 600,
  },
};
/**
 * misc
 */

/**
 * overflow
 */
export const overflowHidden = { overflow: 'hidden' };
export const overflowScrollY = { overflowY: 'scroll' };
export const overflowScrollAuto = { overflowY: 'auto' };

/** border */
export const borderNone = { border: 'none' };
/**
 * pointer
 */
export const pointerEventsNone = { pointerEvents: 'none' };
export const pointerEventsAuto = { pointerEvents: 'auto' };
/**
 * position
 */
export const positionRelative = { position: 'relative' };
export const positionSticky = { position: 'sticky' };
export const positionAbsolute = { position: 'absolute' };
export const positionFixed = { position: 'fixed' };
